import React from 'react';

import { StyledButton } from './styled';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  theme?: string;
  size?: string;
  type?: 'button' | 'submit' | 'reset';
}

const Button: React.FC<ButtonProps> = ({ children, theme = 'primary', size = 'medium', type = 'button', ...rest }) => {
  return (
    <StyledButton type={type} theme={theme} size={size} {...rest}>
      {children}
    </StyledButton>
  );
};

export { Button };
